import { Box, Container, Grid } from "@mui/material";
import ContentHeader from "../../../components/layout/ContentHeader/ContentHeader";
import ContentTitle from "../../../components/layout/ContentTitle/ContentTitle";
import Section from "../../../components/layout/Section/Section";
import NavBreadcrumbs from "../../../components/navigation/NavBreadcrumbs/NavBreadcrumbs";
import { PAGE } from "../../../constants/page";
import ArrowButton from "../../../components/ui/ArrowButton/ArrowButton";
import OtherSection from "../../../components/display/OtherSection/OtherSection";
import Hr from "../../../components/ui/Hr/Hr";

interface Props {
  children?: React.ReactElement<unknown>;
}

export default function System(props: Props) {
  return (
    <>
      <Section color="dark">
        <ContentHeader title={PAGE.SERVICE.NAME} subTitle={PAGE.SERVICE.TEXT} />
      </Section>

      <Section color="light" padding="1rem 0">
        <Container>
          <NavBreadcrumbs />
        </Container>
      </Section>

      <Section color="light">
        <Container>
          <ContentTitle title={'COMING SOON...'} subTitle={'近日公開予定'} />
        </Container>
      </Section>

      <Section height="100px" color="light">
        <Container>
          <Grid>
            <Grid size={12} sx={{ textAlign: 'center' }}>
              <ArrowButton label={PAGE.SERVICE.NAME} href={PAGE.SERVICE.PATH} isLeft />
            </Grid>
          </Grid>
        </Container >
      </Section>

      <Hr />

      <Section color='dark' height={'300px'} backgroundImage='url(/assets/images/top.jpg)' isBackgroundCover>
        <Container>
          <OtherSection isObserver={false} />
        </Container>
      </Section>
    </>
  )
}